module.exports = __webpack_public_path__ + "static/detecht-extraimg2-ba9af7353c23e357543cefb62ff9ba77.png";